import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import Box from "./box";
export default function SectionContent(props) {
  var iw = props.iw,
      imaxw = props.imaxw,
      iminw = props.iminw,
      children = props.children,
      restProps = _objectWithoutProperties(props, ["iw", "imaxw", "iminw", "children"]);

  return /*#__PURE__*/React.createElement(Box, _extends({
    display: "flex",
    "flex-direction": "column",
    width: iw,
    "max-width": imaxw,
    "min-width": iminw,
    "min-height": "16px",
    margin: "0 auto"
  }, restProps, {
    "data-qkind": "SectionContent"
  }), children);
}
;
Object.assign(SectionContent, {
  effects: {
    hover: ":hover"
  }
});